import React, { useCallback, useEffect, useState } from "react";

import {
  faCheck,
  faKey,
  faEnvelope,
  faUserPlus,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mainAxios from "../../../services/mainAxios";
import Loader from "../../Layout/Loader";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppContext } from "../../../AppContext";
import "./styles.scss";
import UsersTable from "./UsersTable";
import { useTranslation } from "react-i18next";
import { EditableTable } from "../../EditableTable";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import selectStyle from "../../../design/selectStyle";
import AlertCertificate from "../../global/AlertCertificate";
import AuthenticationProviders from "./AuthenticationProviders";
import { useKeycloackStore } from "./KeycloackProvider";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import func from "../../../services/functions";

var _ = require("lodash");
const AddUser = (props) => {
  const {
    user: [currentUser],
  } = useAppContext();

  const { t, i18n } = useTranslation("translations");

  const {
    user: [loggedInUser, setLoggedInUser],
    company: [company, setCompany],
    selectedCompany: [selectedCompany],
    getUser
  } = useAppContext();
  const {loading:loadingFromProviderAuth}= useKeycloackStore()
  const [editLoading, setEditLoading] = useState(false);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [tableData, setTableData] = useState(null);
  const location = useLocation();

  const identityProviders = [
    { value: "profisc", label: "ProFisc" },
    { value: "Google", label: "Google" },
    { value: "Microsoft", label: "Microsoft"},
  ];

  const [state, setState] = useState({
    user: null,
    purchaseRoles: null,
    profiscRoles: null,
    companiesForTable: null,
  });

  let userId = props.match.params.id;
  const isLoggedInUser=userId==loggedInUser.id
  const queryParams = new URLSearchParams(location.search);
  const refresh = queryParams.get('refresh');

  const getCurrentUser=()=>{
    return mainAxios
      .post("apiEndpoint/search", {
        object: "GetUser",
        value: null,
        type: "basic",
        params: { id: userId },
      })
      .then((res) => {
        if (res && res.data.content[0]) {
          let user = res.data.content[0];
          setState((state) => ({
            ...state,
            user,
          }));

          if (loggedInUser.role.id != 1 && loggedInUser.role.id != 3) return;
          let userCompanies = user.companiesRights;

          let dataForOperatorCodes = userCompanies
            .map((t2) => {
              let temp = null;

              let exists = user?.userCompanyOperator?.find((t1) => {
                return t2.id === t1.company;
              });

              if (exists) {
                temp = {
                  company_operator: exists.id,
                  id: exists.company,
                  nuis: t2.nuis,
                  company_id: exists.company,
                  company_name: t2.name,
                  operator: exists.operator,
                  recordDate: exists.recordDate,
                  recordUser: exists.recordUser,
                };
              } else {
                temp = {
                  company_operator: null,
                  id: t2.id,
                  nuis: t2.nuis,
                  company_id: t2.id,
                  company_name: t2.name,
                  operator: "",
                };
              }
              return temp;
            })
            .filter(function (el) {
              return el != null;
            });

          setTableData(dataForOperatorCodes);
          return res.data.content[0]
        }
        return null
      })
      .catch(()=>{
        return null
      })
  }

  useEffect(() => {
    getCurrentUser()
    if(refresh){
      history.push({
        pathname: location.pathname,
      });
    }
  }, [userId,refresh]);

  useEffect(() => {
    mainAxios
      .post("apiEndpoint/search", {
        object: "GetRoles",
        value: null,
        type: "basic",
      })
      .then((res) => {
        if (res.data.status == true) {
          setState((state) => ({
            ...state,
            profiscRoles: res.data.content[0],
            purchaseRoles: res.data.content[1],
            paymentRoles: res.data.content[2],
          }));
        }
      });
  }, []);

  const mfaOptions = [
    {
      value: 1,
      label: "Email",
    },
    {
      value: 2,
      label: "Sms",
    },
    {
      value: 3,
      label: t("invoice.disabled"),
    },
  ];

  const sendNotificationOptions = [
    { value: true, label: t("company.yes") },
    { value: false, label: t("company.no") },
  ];

  const editUser = (e) => {
    e.preventDefault();
    // const { userCompanyOperator, ...userToUpdate } = state.user;
    const { companiesRights, userCompanyOperator,userProviders, ...userToUpdate } =
      state.user;
    if (state.user?.phone == "" && state.user.mfa === 2) {
      toast.error(t("users.mfaSmsError"), {
        containerId: "all_toast",
      });
      return;
    }
    setEditLoading(true);
    mainAxios
      .post("apiEndpoint/saveOrUpdate", {
        object: "User",
        content: userToUpdate,
        nuis: loggedInUser.companiesRights.find(
          (company) => company.id === parseInt(selectedCompany)
        )?.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          setState((state) => ({
            ...state,
            error: null,
          }));
          toast.success(t(["toast.userUpdate"]), {
            containerId: "all_toast",
          });
          if(isLoggedInUser){
            getUser()
          }else if([1, 3].includes(loggedInUser.role.id)) {
              props.history.goBack();
          }
        } else {
          toast.error(t("users.errorOccurred"), {
            containerId: "all_toast",
          });
        }
        setEditLoading(false);
      })
      .catch((err) => {
        setEditLoading(false);
      });
  };
  const handleUserInputs = (e, selectedKey, selectedValue) => {
    const key = e ? e?.target?.name : selectedKey;
    let value = e ? e?.target?.value : selectedValue;

    setState((state) => ({
      ...state,
      user: {
        ...state.user,
        [key]: value,
      },
    }));
  };

  const columns = [
    {
      name: t("navbar.companies"),
      selector: "company_name",
      sortable: true,
      editable: false,
    },
    {
      name: t("company.operatorCode"),
      selector: "operator",
      //sortable: true,
      editable: true,
    },
  ];

  const getOperator = (prev, companyOperator) => {
    let data = {
      object: "UserCompanyOperator",
      content: {
        company: companyOperator.company_id,
        user: state.user.id,
        operator: companyOperator.operator,
        recordDate: companyOperator.recordDate,
        recordUser: companyOperator.recordUser,
      },
      username: state.user.username,
      nuis: companyOperator.nuis,
    };

    if (prev.operator) {
      let op = tableData.find(
        (op) => op.company_id === companyOperator.company_id
      );
      data.content.id = op.company_operator;
    }
    mainAxios.post("apiEndpoint/saveOrUpdate", data).then((res) => {
      if (res?.data?.status === true) {
        //console.log(res.data.content[0])

        let newOperators = [...tableData];
        newOperators = newOperators.map((op) => {
          //console.log({op})
          if (op.company_id === companyOperator.company_id) {
            //console.log("found the op to update", {op})

            let operator = {
              company_operator: res.data.content[0].id,
              id: companyOperator.company_id,
              nuis: companyOperator.nuis,
              company_id: companyOperator.company_id,
              company_name: companyOperator.company_name,
              operator: companyOperator.operator,
            };
            return operator;
          } else return op;
        });

        setTableData([...newOperators]);
        if(isLoggedInUser){
          getUser()
        }
        toast.success(t("users.operatorCodeChanged"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
          containerId: "all_toast",
        });
      }
    });
  };

  let filteredProfiscRoles = state?.profiscRoles;
  if (loggedInUser?.role?.id != 1 && state?.user?.role?.id != 1) {
    filteredProfiscRoles = state?.profiscRoles?.filter(
      (role) => role?.id !== 1
    );
  }
  filteredProfiscRoles = filteredProfiscRoles?.map((role) => ({
    label: role.name,
    value: role.id,
    ...role,
  }));

  const purchaseRolesOptions = state.purchaseRoles?.map((role) => ({
    label: role.name,
    value: role.id,
    ...role,
  }));

  const paymentRoles = state.paymentRoles?.map((role) => ({
    label: role.name,
    value: role.id,
    ...role,
  }));

  const isRoleDisabled =
    (loggedInUser?.role?.id != 1 && loggedInUser?.role?.id != 3) ? state?.user?.role?.id != 1 : false;
  const isUserAdmin = loggedInUser?.role?.id == 3;

  const apiSourceOptions = [
    { label: t("company.yes"), value: "true" },
    { label: t("company.no"), value: "false" }
  ]

  const addUserInKeycloack = ()=>{
    mainAxios.post("/api/keycloak/createUser",{
      userId:parseInt(userId),
      record_user:currentUser.username
    })
    .then(res=>{
      if(res.data.status){
        toast.success(t("toast.userAddedInKeycloack"), {
          containerId: "all_toast",
        });
        getCurrentUser();
      }
    })
  }

  const inviteUser = (provider) => {
    if (!state.user?.email) {
      toast.error(t("toast.emailError"), {
        containerId: "all_toast",
      });
      return;
    }

    setInviteLoading(true);
    const companyNuis = loggedInUser.companiesRights.find(
      (comp) => comp.id === parseInt(selectedCompany)
    )?.nuis;

    mainAxios.post("/invitations/inviteUser", {
      params: {
        invitedUser: state.user.id.toString(),
        provider: provider,
        invitedFrom: currentUser.username
      },
      nuis: companyNuis
    },{showErrorToast:false})
    .then(res => {
      if (res?.status == 200 || res?.data?.message?.includes("Email sent")) {
        toast.success(t("invite.invitationSent"), {
          containerId: "all_toast",
        });
      } else {
        toast.error(res?.data?.message || t("invite.invitationFailed"), {
          containerId: "all_toast",
        });
      }
      setInviteLoading(false);
    })
    .catch(err => {
      toast.error(t("invite.invitationFailed"), {
        containerId: "all_toast",
      });
      setInviteLoading(false);
    });
  }

  const paymentRoleFormat=useCallback((option) => {
    const key = `users.${option.name}`;
    const translated = t(key, { defaultValue: null });
    if (translated) return translated;

    return func.capitalizeFirstLetter(option.name)
},[t])

const history = useHistory()

  if(loadingFromProviderAuth|| !state?.user ){
    return (
      <Loader />
    )
  }
  return (
    <div className="row mt-5">
      <form
        className="col-xl-6 col-lg-6 col-md-8 col-sm-10 col-12 mx-auto"
        onSubmit={(e) => editUser(e)}
      >
        <div className="card filter-card-dashboard shadow mb-4">
            <div className="card-title p-3 ml-2 text-left d-flex align-items-center">
              <h3 className="mb-0 mr-2">{t("users.editUser")}</h3>
              <AlertCertificate />
            </div>
          <div className="card-body">
            <div className="row">
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="first_name">{t("users.firstName")}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="first_name"
                    name="firstName"
                    placeholder="E.g. 'John'"
                    value={state.user.firstName}
                    disabled={isRoleDisabled}
                    onChange={handleUserInputs}
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="last_name">{t("users.lastName")}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="last_name"
                    name="lastName"
                    disabled={isRoleDisabled}
                    placeholder="E.g. 'Smith'"
                    value={state.user.lastName}
                    onChange={handleUserInputs}
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="active">{t("company.active")}</label>
                  <select
                    className="form-control"
                    id="active"
                    name="active"
                    disabled={isRoleDisabled}
                    value={state.user.active}
                    onChange={handleUserInputs}
                  >
                    <option value="false">{t("company.no")}</option>
                    <option value="true">{t("company.yes")}</option>
                  </select>
                </div>
              </div>
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="phone">{t("users.phone")}</label>
                  <PhoneInput
                    country="al"
                    inputStyle={{ width: "100%" }}
                    value={state?.user?.phone ?? ""}
                    disabled={isRoleDisabled}
                    placeholder="E.g. '+355690000000'"
                    onChange={(value) => handleUserInputs(null, "phone", value)}
                  />
                </div>
              </div>
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="role">{t("users.role")}</label>
                  <Select
                    styles={selectStyle}
                    className="w-100"
                    options={filteredProfiscRoles}
                    isDisabled={isRoleDisabled}
                    value={filteredProfiscRoles?.find(
                      (role) => role.value == state.user?.role?.id
                    )}
                    onChange={(role) =>
                      handleUserInputs(null, "role", {
                        id: role.id,
                        name: role.name,
                      })
                    }
                    name="role"
                  />
                </div>
              </div>
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="purchaseRole">
                    {t("users.purchaseRoles")}
                  </label>
                  <Select
                    styles={selectStyle}
                    className="w-100"
                    options={purchaseRolesOptions}
                    isDisabled={isRoleDisabled}
                    value={purchaseRolesOptions?.find(
                      (role) => role.value == state.user?.purchaseRole?.id || ""
                    )}
                    onChange={(purchRole) =>
                      handleUserInputs(null, "purchaseRole", {
                        id: purchRole.id,
                        name: purchRole.name,
                      })
                    }
                    name="purchaseRole"
                  />
                </div>
              </div>
              {/* Payment roles */}
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="paymentsRole">
                    {t("users.paymentRoles")}
                  </label>
                  <Select
                    styles={selectStyle}
                    className="w-100"
                    options={paymentRoles}
                    getOptionLabel={paymentRoleFormat}
                    isDisabled={isRoleDisabled || isUserAdmin}
                    value={paymentRoles?.find(
                      (role) => role.value == state.user?.paymentsRole?.id || ""
                    )}
                    onChange={(pyamentRole) =>
                      handleUserInputs(null, "paymentsRole", {
                        id: pyamentRole.id,
                        name: pyamentRole.name,
                      })
                    }
                    name="paymentsRole"
                  />
                </div>
              </div>
              {loggedInUser.role.id == 1 && (
                <div className="col-xl-6 col-12">
                  <div className="form-group">
                    <label htmlFor="mfa">{t("users.mfaType")}</label>
                    <Select
                      styles={selectStyle}
                      className="w-100"
                      options={mfaOptions}
                      value={mfaOptions.find(
                        (mfa) => mfa.value == state.user?.mfa
                      )}
                      isDisabled={isRoleDisabled}
                      onChange={(mfa) => {
                        handleUserInputs(null, "mfa", mfa.value);
                      }}
                      name="mfa"
                    />
                  </div>
                </div>
              )}

              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="username">{t("users.username")}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    placeholder="E.g. 'johnsmith'"
                    value={state.user.username}
                    onChange={handleUserInputs}
                    disabled
                  />
                </div>
              </div>
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  

                  <label htmlFor="username">{t("users.userInKeycloak")}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    placeholder="E.g. 'johnsmith'"
                    value={state?.user?.keycloakUser  ? t("company.yes") :  t("company.no")}
                    onChange={handleUserInputs}
                    disabled
                  />
                </div>
              </div>
              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="email">{t("email.email")}</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="E.g. 'johnsmith@example.com'"
                    value={state.user.email}
                    onChange={handleUserInputs}
                    disabled={isRoleDisabled}
                  />
                </div>
              </div>
              <div className="col-xl-6 col-12">
              <div className="form-group">
                  <label htmlFor="active">{t("users.apisource")}</label>
                  <Select
                    styles={selectStyle}
                    className="w-100"
                    options={apiSourceOptions}
                    isDisabled={isRoleDisabled || isUserAdmin}
                    value={apiSourceOptions?.find((opt) => opt.value == (state?.user?.apiSource ?? "")?.toString() || "")}
                    onChange={(opt) => { handleUserInputs(null, "apiSource", opt.value) }}
                  />
                </div>
                </div>

              <div className="col-xl-6 col-12">
                <div className="form-group">
                  <label htmlFor="receiveAdministrativeNotification">
                    {t("users.reciveAdministrativeNotification")}
                  </label>
                  <Select
                    styles={selectStyle}
                    className="w-100"
                    options={sendNotificationOptions}
                    isDisabled={isRoleDisabled}
                    value={sendNotificationOptions.find(
                      (notification) =>
                        notification.value ==
                        state.user?.receiveAdministrativeNotification
                    )}
                    onChange={(notification) => {
                      handleUserInputs(
                        null,
                        "receiveAdministrativeNotification",
                        notification?.value
                      );
                    }}
                    name="receiveAdministrativeNotification"
                  />
                </div>
              </div>
              </div>
            <div className="d-flex align-items-center mt-4">
              <button
                type="submit"
                disabled={editLoading}
                style={{ minWidth: "120px" }}
                className="btn btn-primary"
              >
                {editLoading ? (
                  <Loader size="xs" color="white" />
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCheck} className="mr-2" />
                    {t("common.save")}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        <div className="card filter-card-dashboard shadow mb-4">
          <div className="card-title p-3 mb-1  ml-2 text-left">
            <h3 className="mb-0">{t("users.userActions")}</h3>
          </div>
          <div className="card-body pt-1">
            <div className="mb-4">
              <h5 className="mb-2">{t("users.accountSettings")}</h5>
              <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
                <Link
                  to={"/users/edit-email/" + state.user.id}
                  className="btn btn-outline-primary d-flex align-items-center"
                >
                  <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
                  {t("users.changeEmail")}
                </Link>

                {state?.user?.active === true && (
                  loggedInUser?.role?.id === 3 ? (
                    <button
                      type="button"
                      className="btn btn-outline-secondary d-flex align-items-center"
                      disabled
                    >
                      <FontAwesomeIcon icon={faKey} className="mr-2" />
                      {t("users.changePassword")}
                    </button>
                  ) : (
                    <Link
                      to={"/users/edit-password/" + state.user.id}
                      className="btn btn-outline-primary d-flex align-items-center"
                    >
                      <FontAwesomeIcon icon={faKey} className="mr-2" />
                      {t("users.changePassword")}
                    </Link>
                  )
                )}

                {!state?.user?.keycloakUser && [1, 3].includes(loggedInUser.role?.id) && (
                  <button
                    type="button"
                    className="btn btn-outline-primary d-flex align-items-center"
                    onClick={() => addUserInKeycloack()}
                  >
                    <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
                    {t("users.addToKeycloak")}
                  </button>
                )}
              </div>
            </div>
            {[1, 3].includes(loggedInUser.role?.id) && <div className="border-top pt-4">
              <h5 className="mb-2">{t("users.sendInvitation")}</h5>
              <p className="text-muted mb-2">
                {t("users.invitationDescription")}
              </p>
              <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
                {identityProviders.map((provider) => (
                  <button
                    key={provider.value}
                    type="button"
                    className="btn btn-outline-success d-flex align-items-center px-4"
                    style={{ minWidth: "140px" }}
                    disabled={inviteLoading}
                    onClick={() => inviteUser(provider.value)}
                  >
                    {inviteLoading ? (
                      <Loader size="xs" />
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faPaperPlane} className="mr-2" />
                        {provider.label}
                      </>
                    )}
                  </button>
                ))}
              </div>
            </div>}
          </div>
        </div>

        {tableData && (
          <div className="card filter-card-dashboard shadow mb-4">
            <div className="card-title p-3 ml-2 text-left d-flex align-items-center">
              <h3 className="mb-0">{t("users.operatorCodes")}</h3>
            </div>
            <div className="card-body">
              <EditableTable
                columns={columns}
                data={[...tableData]}
                getEditedData={getOperator}
              />
            </div>
          </div>
          
        )}
      </form>
      {
        <div className="col-xl-5 col-lg-6 col-md-8 col-sm-10 col-12 mx-auto" style={{ backgroundColor: '#fff' }}>
          {[1].includes(loggedInUser.role?.id) && (
          <UsersTable state={state} setState={setState} refreshUser={getCurrentUser}/>
          )}
          <AuthenticationProviders state={state} getCurrentUser={getCurrentUser}/>
        </div>
      }

    </div>
  )
};

export default AddUser;
